import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { initialState } from 'store/oauth/reducer';
import { RequestStatus } from 'types';
import { State, Token, Introspect } from 'store/oauth/types';
import { RequestStatusTypes } from 'consts';

const selectState = (state: RootState) => state.oauth || initialState;

// Directly reducer
export const makeSelectToken = () =>
  createSelector(selectState, (state: State): Token => state.token);

export const makeSelectGettingToken = () =>
  createSelector(selectState, (state: State): boolean => state.gettingToken);

export const makeSelectIntrospect = () =>
  createSelector(selectState, (state: State): Introspect => state.introspect);

// Combined
export const makeSelectTokenTokenType = () =>
  createSelector(makeSelectToken(), (token: Token): string => token.token_type);

export const makeSelectTokenAccessToken = () =>
  createSelector(
    makeSelectToken(),
    (token: Token): string => token.access_token
  );

export const makeSelectTokenBearerToken = () =>
  createSelector(
    makeSelectTokenTokenType(),
    makeSelectTokenAccessToken(),
    (token_type: string, access_token: string): string =>
      `${token_type} ${access_token}`
  );

// Requests statuses
export const makeSelectGetTokenRequestStatus = () =>
  createSelector(
    selectState,
    (state: State): RequestStatus => state.getTokenRequestStatus
  );

export const makeSelectGetTokenRequestStatusIsLoading = () =>
  createSelector(
    makeSelectGetTokenRequestStatus(),
    (getTokenRequestStatus: RequestStatus): boolean =>
      getTokenRequestStatus.status === RequestStatusTypes.Loading
  );

export const makeSelectGetIntrospectRequestStatus = () =>
  createSelector(
    selectState,
    (state: State): RequestStatus => state.getIntrospectRequestStatus
  );

export const makeSelectForbiddenAccess = () =>
  createSelector(selectState, (state: State): string => state.forbiddenAccess);
